module.exports = __webpack_public_path__ + "assets/img/LTC013.a4aeaf5e.png";